import { render } from "./ScheduleOrderForDelivery.html?vue&type=template&id=95b3cbd0&scoped=true"
import script from "./ScheduleOrderForDelivery.js?vue&type=script&lang=js"
export * from "./ScheduleOrderForDelivery.js?vue&type=script&lang=js"

import "./ScheduleOrderForDelivery.css?vue&type=style&index=0&id=95b3cbd0&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95b3cbd0"]])

export default __exports__